// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"DashboardCA_dashboardWrapper__T35mY","blob":"DashboardCA_blob__RbFfk"};